// management-frontend/src/context/AuthContext.js

import { createContext, useContext, useEffect, useState } from "react";
import apiServices from "../services/apiServices";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);

  // Função para verificar se o token está expirado
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      // JWT exp está em segundos, Date.now() em milissegundos
      return decoded.exp * 1000 < Date.now();
    } catch (error) {
      // Se houver erro na decodificação, consideramos como expirado
      return true;
    }
  };

  useEffect(() => {
    setLoading(true);

    const storedToken = localStorage.getItem("token");

    if (!storedToken) {
      logout();
      setLoading(false);
      return;
    }

    // Verifica se o token está expirado
    if (isTokenExpired(storedToken)) {
      logout();
      setLoading(false);
      return;
    }

    // Se o token é válido, atualiza o estado e decodifica o usuário
    setToken(storedToken);
    const decoded = jwtDecode(storedToken);
    setUser(decoded); // Armazena informações do usuário decodificadas

    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const api = new apiServices();
    var status = { success: false, initialPassword: false };
    setLoading(true);

    try {
      const data = await api.authLogin(email, password);

      if (data?.token) {
        localStorage.setItem("token", data.token);
        setToken(data.token);
        const decoded = jwtDecode(data.token);
        setUser({ ...decoded, fullname: data.fullname, initialPassword: data.initialPassword });
        status.initialPassword = data.initialPassword;
        status.success = true;
      }
    } catch (error) {
      console.error("Erro no login:", error);
    }

    setLoading(false);
    return status;
  };

  const forgotPassword = async (email) => {
    const api = new apiServices();

    try {
      const data = await api.authForgot(email);

      if (data) return true;
      else return false;
    } catch (error) {
      console.error("Erro no forgotPassword:", error);
      return false;
    }
  };

  const logout = async () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  const changePassword = async (id, password) => {
    try {
      const api = new apiServices();
      await api.changePassword(id, password);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        loading,
        changePassword,
        token,
        forgotPassword,
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
